'use client';
import { AxiosResponse } from 'axios';

import { nestApiClient } from './api-client';

export const validateTwitchCode = (params: {
  code: string;
  redirectUrl: string;
}) => {
  return nestApiClient.get<AxiosResponse>('/twitch/token', {
    params,
  });
};

export const getTwitchRemove = () => {
  return nestApiClient.get<AxiosResponse>(`/twitch/remove`);
};
